var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.usesExternalUrl)?_c('a',{attrs:{"href":_vm.project.external_url,"target":_vm.externalTarget,"rel":_vm.externalRel}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":{
    name: 'ProjectDetail',
    params: { project_id: _vm.project.link },
  }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }